<template>
  <div class="loading-box" v-show="show" @click="taggle(false)">
    <div class="loading">
      加载中···
    </div>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        show: true
      }
    },
    methods: {
      taggle(status){
        this.show = status || !this.show;
      }
    }
  }
</script>
<style lang="scss">
  .loading-box{
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    .loading{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      padding-top: 16vw;
      background: url(~@/assets/imgs/loading.gif) center 0 no-repeat;
      background-size: 14vw;
      /* color: #e65757; */
    }
    .iconfont{
      display: block;
      margin: 0 auto .5em;
      font-size: 2em;
      animation: rotation 1.5s infinite;
    }
  }
  @keyframes rotation {
    0% {
        transform:rotate(0);
        animation-timing-function:cubic-bezier(.55,.055,.675,.19)
      }
      50% {
          transform:rotate(360deg);
          animation-timing-function:cubic-bezier(.215,.61,.355,1)
      }
      100% {
          transform:rotate(720deg)
      }
  }
</style>